<template>
  <div>
    <div class="footer">
      <!-- 国内小计： -->
      <div class="item">
        <!-- 国内小计： 
          -->
        <h6>{{ $t("message.domesticSubtotal") }}:
          <span>
            <el-checkbox v-model="detail.goods_fee_rule" style="margin-left: 20px;"
              v-if="detail.type == 2 && status >= 22" :disabled="status != 22"
              @change="updateOrderPayRule">无需支付商品代</el-checkbox>
            <!-- <el-checkbox v-model="detail.service_fee_rule" v-if="detail.type == 2 && status >= 22"
              :disabled="status != 22">按照等级收手续费</el-checkbox> -->
          </span>

        </h6>
        <div class="border"></div>
        <!-- 商品金额： -->
        <div class="row">
          <div class="label">{{ $t("message.goodsAmount") }}:</div>
          <!-- 人民币  -->
          <div class="rmb">{{ ceil(total.goodsAmount) }} 元</div>
          <!-- 日元  -->
          <div class="ry">
            {{ ceilYen((total.goodsAmount * baseRate)) }} 円
          </div>
        </div>
        <!-- 国内运费 -->
        <div class="row">
          <div class="label">{{ $t("message.domesticFreight") }}:</div>
          <!-- 人民币  -->
          <div class="rmb">{{ ceil(total.domesticFreight) }}元</div>
          <!-- 日元  -->
          <div class="ry">
            {{ ceilYen(total.domesticFreight * baseRate) }} 円
          </div>
        </div>
        <!-- 手续费(10%): -->
        <div class="row">
          <div class="label">
            {{ $t("message.poundage") }}:
          </div>
          <!-- 人民币  -->
          <div class="rmb">{{ poundage }} 元</div>
          <!-- 日元  -->
          <div class="ry">{{ ceilYen(poundage * baseRate) }} 円</div>
        </div>
        <!-- 附加服务费 -->
        <div class="row">
          <div class="label">{{ $t("message.additionalServiceCharge") }}:</div>
          <!-- 人民币  -->
          <div class="rmb">
            {{ ceil(total.additionalServiceCharge) }} 元
            <!-- 详细 -->
            <el-button type="text" @click="$refs.additionalServiceCharge.dialogVisible = true"
              v-if="total.additionalServiceCharge > 0">
              {{ $t('message.detail') }}
            </el-button>
          </div>
          <!-- 日元  -->
          <div class="ry">
            {{ ceilYen(total.additionalServiceCharge * baseRate) }} 円
          </div>
        </div>
        <!-- 其他费用： -->
        <div class="row">
          <div class="label">{{ $t("message.otherFees") }}:</div>
          <!-- 人民币  -->
          <div class="rmb">
            <div class="input fl" style="width: 65%" v-if="status == 22">
              <el-input v-model="detail.other_price" onfocus="this.select()" @input="handleInput"></el-input>
            </div>
            <span v-else>{{ detail.other_price }}</span>
            元
          </div>
          <!-- 日元  -->
          <div class="ry">
            {{ ceilYen(detail.other_price * baseRate) }} 円
          </div>
        </div>
        <!-- 其他费用备注: -->
        <div class="row">
          <div class="label">{{ $t("message.otherFeesRemark") }}:</div>
          <!--  -->
          <div class="input">
            <el-input v-model="detail.other_price_remark" onfocus="this.select()" v-if="status == 22"></el-input>
            <span v-else>
              {{ detail.other_price_remark }}
            </span>
          </div>
        </div>
        <div class="border"></div>
        <!-- 合计 -->
        <div class="row">
          <div class="label">{{ $t("message.total") }}:</div>
          <!-- 人民币  -->
          <div class="label">{{ ceil(domesticSubtotal) }} 元</div>
          <!-- 日元  -->
          <div class="label">
            {{ ceilYen(domesticSubtotal * baseRate) }} 円
          </div>
        </div>
        <!-- 实际支付 -->
        <div class="row" v-if="detail.type == 2 && status >= 22">
          <div class="label">{{ $t("message.actualAmount") }}:</div>
          <!-- 人民币  -->
          <div class="label">{{ ceil(actualAmount) }} 元</div>
          <!-- 日元  -->
          <div class="label">
            {{ ceilYen(actualAmount * baseRate) }} 円
          </div>
        </div>
        <div class="border"></div>
        <!-- 分批汇款 -->
        <div class="row" v-if="status >= 22 && detail.type != 2">
          <div class="label">{{ $t("message.partialRemittance") }}:</div>
          <!-- 是否分批付款  -->
          <div class="input">
            <el-radio v-model="detail.part_pay_status" :label="1" :disabled="!isAuth(531)">是</el-radio>
            <el-radio v-model="detail.part_pay_status" :label="0" :disabled="!isAuth(531)">否</el-radio>
          </div>
          <!-- 设置 -->
          <div class="label" v-if="isAuth(531)">
            <el-button type="text" @click="$refs.partialRemittance.dialogVisible = true">
              {{ $t("message.Settings") }}
            </el-button>
          </div>
        </div>
        <!-- 生效为 0，不生效为 1；豁免选择随临时保存或报价提交。 -->
        <div class="row small-order-fee-exempt" v-if="status == 22 && showSmallOrderSpecialFee">
          <div class="label">{{ $t('message.smallOrderSpecialFee') }}:</div>
          <div class="input">
            <el-radio v-model="detail.small_order_fee_exempt" :label="0" :disabled="!isAuth(784)">
              {{ $t('message.smallOrderFeeActive') }}
            </el-radio>
            <el-radio v-model="detail.small_order_fee_exempt" :label="1" :disabled="!isAuth(784)">
              {{ $t('message.smallOrderFeeInactive') }}
            </el-radio>
          </div>
        </div>
      </div>
      <!-- 国际小计： -->
      <div class="item international">
        <!-- 国际小计 -->
        <h6>{{ $t("message.internationalSubtotal") }}:</h6>
        <div class="border"></div>
        <!-- 今日汇率： -->
        <div class="row">
          <div class="label">{{ $t("message.nowRate") }}:</div>
          <!-- 日元  -->
          <div class="ry">1CNY = {{ baseRate }}円</div>
        </div>
        <!-- 合计体积(m³) -->
        <div class="row">
          <div class="label">{{ $t("message.totalVolume") }}(m³):</div>
          <div class="rmb"> <el-input v-model="total.totalVolume" v-if="status >= 22" @blur="estimatedShipping">
              <span slot="append">m³</span></el-input>
            <span v-else>{{ total.totalVolume }}m³</span>
          </div>
        </div>
        <!--  合计重量(kg)： -->
        <div class="row">
          <div class="label">{{ $t("message.totalWeights") }}(kg):</div>
          <div class="rmb">
            <el-input v-model="total.totalWeight" v-if="status >= 22" @blur="estimatedShipping">
              <span slot="append">kg</span></el-input>
            <span v-else>{{ total.totalWeight }}kg</span>
          </div>
        </div>
        <!--客户指定运公司 -->
        <div class="row">
          <div class="label">
            {{ $t("message.customerDesignatedShippingCompany") }}:
          </div>
          <div class="rmb">
            <el-select v-model="detail.logistics_id" placeholder="请选择" v-if="logisticsList != false"
              :disabled="status != 22" @change="updateOrderLogistics">
              <el-option v-for="item in logistics" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </div>
        </div>
        <!-- 国际运费预估(元): -->
        <div class="row" v-if="status >= 22">
          <div class="label">
            {{ $t("message.internationalShippingEstimate") }}(円):
          </div>
          <!-- 人民币  -->
          <div class="rmb estimate">
            <el-input v-model="detail.predict_logistics_price" v-if="status == 22"></el-input>
            <span v-else> {{ detail.predict_logistics_price }}</span>
            <!-- 预估运费 -->
            <el-button type="text" size="small" @click="estimatedShipping" v-if="status == 22">
              {{ $t("message.estimatedShipping") }}</el-button>
          </div>
        </div>
        <!-- 国际运费预估(元): -->
        <div class="row" v-if="status >= 22">
          <div class="label">
            {{ $t("message.internationalShippingEstimate") }}(元):
          </div>
          <!-- 人民币  -->
          <div class="rmb estimate">
            <span> {{ (detail.predict_logistics_price / baseRate).toFixed(2) }}元 </span>
          </div>
        </div>
        <!--    其它物流方式预估运费查看 -->
        <div class="row" v-if="status >= 22">
          <div class="label">
          </div>
          <div class="rmb estimate">
            <el-button type="text" size="small" @click="estimatedShippingLook" v-if="status == 22">
              其它物流方式预估运费查看
            </el-button>
          </div>
        </div>
        <!--工厂直发，计算费用  -->
        <div v-if='detail.type == 8 || detail.type == 2'>
          <!--算业务绩效 -->
          <div class="row">
            <div class="label">
              {{ $t("message.calculateBusinessPerformance") }}:
            </div>
            <div class="rmb">
              <el-checkbox v-model="detail.order_augment.is_y_performance" @change="updateOrderPerformance"
                :disabled="!isAuth(569)"></el-checkbox>
            </div>
          </div>
          <!--算采购绩效 -->
          <div class="row">
            <div class="label">
              {{ $t("message.calculateProcurementPerformance") }}:
            </div>
            <div class="rmb">
              <el-checkbox v-model="detail.order_augment.is_g_performance" @change="updateOrderPerformance"
                :disabled="!isAuth(569)"></el-checkbox>
            </div>
          </div>
          <!--算配货绩效 -->
          <div class="row">
            <div class="label">
              {{ $t("message.calculateDistributionPerformance") }}:
            </div>
            <div class="rmb">
              <el-checkbox v-model="detail.order_augment.is_p_performance" @change="updateOrderPerformance"
                :disabled="!isAuth(569)"></el-checkbox>
            </div>
          </div>

        </div>
        <!--航空便单价(元) -->
        <div class="row" v-if="status >= 22 && isCustomMade">
          <div class="label">
            {{ $t("message.airlineFare") }}(元):
          </div>
          <div class="rmb">
            <el-input v-model="detail.order_bulk.air_price"
              @input="orderBulkPrice('air_price', detail.order_bulk.air_price)"
              @blur="orderBulkUpdatePrice('air_price', detail.order_bulk.air_price)">
              <span slot="append">元</span></el-input>
          </div>
        </div>
        <!--船便的单价(元)： -->
        <div class="row" v-if="status >= 22 && isCustomMade">
          <div class="label">
            {{ $t("message.shipFare") }}(元):
          </div>
          <div class="rmb">
            <el-input v-model="detail.order_bulk.sea_price"
              @input="orderBulkPrice('sea_price', detail.order_bulk.sea_price)"
              @blur="orderBulkUpdatePrice('sea_price', detail.order_bulk.sea_price)">
              <span slot="append">元</span></el-input>
          </div>
        </div>
        <!--船便的单价(元)： -->
        <div class="row" v-if="status > 22 && isCustomMade">
          <div class="label">
            <!-- 原価計算書 -->
            <el-button type="primary" @click="downloadCostCalculation">原価計算書</el-button>
          </div>

        </div>
      </div>
      <!-- 客户订单备注： -->
      <div class="item">
        <!-- 客户订单备注 -->
        <h6>{{ $t("message.customerOrderNotes") }}:</h6>
        <el-input type="textarea" v-model="detail.client_remark" show-word-limit disabled>
        </el-input>
        <!-- 业务翻译备注 -->
        <h6 style="margin-top: 35px">
          业务翻译订单备注:
        </h6>
        <el-input type="textarea" placeholder="业务翻译备注" v-model="detail.y_remark" show-word-limit onfocus="this.select()"
          @blur="yRemarkEdit">
        </el-input>
        <!-- 客户订单备注回复 -->
        <h6 style="margin-top: 35px" v-if="status >= 22">
          给客户进行回复:
        </h6>
        <el-input type="textarea" placeholder="业务回复" v-model="detail.y_reply" show-word-limit onfocus="this.select()"
          v-if="status >= 22">
        </el-input>
        <!-- 跟进注意事项 -->
        <h6 style="margin-top: 35px">
          客户订单管理（日文-填写后客户可同步编辑查看）:
        </h6>
        <el-input type="textarea" placeholder="客户订单管理（日文-填写后客户可同步编辑查看）" v-model="detail.follow_remark"
          @blur="followRemarkEdit" onfocus="this.select()">
        </el-input>
      </div>
      <!-- 客户添加附件： -->
      <div class="item commodityMaterial">
        <!-- 品名材质 -->
        <!-- 编辑 -->
        <div class="row">
          <div class="label">{{ $t("message.commodityMaterial") }} :</div>
          <div class="val">
            {{ orderMaterial }} / {{ detail.order_detail.length }}
            <el-button type="text" class="fr" @click="$parent.isProductNameEditor = true" v-if="isAuth(182)">
              {{ $t("message.redact") }}
            </el-button>
          </div>
        </div>
        <h6>{{ $t("message.customersAddAttachments") }}:</h6>
        <div class="row" v-for="(item, index) in detail.order_file" :key="index">

          <div class="attachment">
            <div class="name">
              <el-button size="mini" :type="item.admin_id ? 'primary' : 'success'">
                {{ item.admin_id ? item.admin.realname : '客户' }}</el-button> {{ item.name }}
              <div class="time">{{ item.created_at }}</div>

            </div>
            <el-image style=" height: 40px; float: right; vertical-align: middle;" :src="item.file"
              :preview-src-list="[item.file]"
              v-if="item.file.indexOf('jpg') != -1 || item.file.indexOf('png') != -1 || item.file.indexOf('jpeg') != -1">
            </el-image>
            <a :href="item.file" download target="_blank" rel="noopener noreferrer" v-else>
              <span>下载</span></a>
            <a href="javaScript:;" download class=" del" @click="deleteOrderFile(item.id, index)"> <span>删除</span></a>
          </div>
        </div>
        <!-- 进图条 -->
        <el-progress :percentage="schedule" v-if="schedule != 100"></el-progress>
        <!-- 上传 -->
        <el-upload class="upload-demo" :action="baseURL + '/api/common/uploadFile'" :show-file-list="false"
          :before-upload="beforeAvatarUpload" :http-request="httpup" multiple>
          <el-button type="primary">
            点击上传
          </el-button>
        </el-upload>
      </div>
    </div>
    <!-- 预估国际费用 -->
    <InternationalFreight ref="InternationalFreight" :data="forecastExpense" />
    <!-- 分批付款设置 -->
    <partialRemittance :total="total" ref="partialRemittance" />
    <!-- 分批付款显示  -->
    <paymentInInstallments v-if="detail.part_pay_status == 1 && detail.order_part_pay != false" :total="total" />
    <!-- 附加服务 -->
    <additionalServiceCharge ref="additionalServiceCharge" :detail="detail" />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import NP from 'number-precision'
import InternationalFreight from "./InternationalFreight";
import partialRemittance from './partialRemittance.vue'
import paymentInInstallments from './paymentInInstallments.vue'
import { downloadFileRename } from '@/utlis/download'
import additionalServiceCharge from './additionalServiceCharge'
import { transferDate } from '@/utlis/date'
export default {
  components: {
    InternationalFreight,
    partialRemittance,
    paymentInInstallments,
    additionalServiceCharge
  },
  props: {
    total: { type: Object },
    status: { type: Number },
    orderMaterial: { type: Number }
  },
  data() {
    return {
      environment: location.host.indexOf('.com') !== -1 ? false : true, // 是否开发环境
      order_sn: this.$route.query.order_sn,
      forecastExpense: {},// 其它物流方式预估运费查看 参数
      logisticsFreight: [],
      userRoleInfo: JSON.parse(localStorage.getItem('japanUserRoleInfo')),
      personalProcedures: 0,// 个人手续费
    };
  },
  mounted() {
    let user_id = this.order_sn.split('-')[1]
    this.$api.orderApi.userLevelRate({ user_id }).then((res) => {
      this.personalProcedures = res.data[0].rate


    })
    // if (this.detail.status == 22) {}
    //   this.estimatedShipping()
    // }
  },
  computed: {
    ...mapState({
      detail: (state) => state.orderDetail.detail,
      logisticsList: (state) => state.porderDetail.logisticsList,
      rate: (state) => state.rate,
      schedule: (state) => state.schedule,
    }),
    // V5及以上、定额会员（付费会员）和SVIP不展示小客户特殊收费勾选项。
    showSmallOrderSpecialFee() {
      const user = this.detail.user
      if (!user) return false
      const level = user.user_level && /^V(\d+)$/i.exec(user.user_level.level_name)
      const highLevel = level && Number(level[1]) > 4
      const paidMember = user.attribute && [1, 2].includes(Number(user.attribute.id))
      return !highLevel && !paidMember
    },
    baseRate() {
      return this.detail.status == 40 ? this.detail.exchange_rate : this.rate
    },

    // 国内小计
    domesticSubtotal() {
      let num = 0
      num = (
        this.total.goodsAmount -
        0 +
        (this.total.domesticFreight - 0) +
        (this.poundage - 0) +
        (this.total.additionalServiceCharge - 0) +
        (this.detail.other_price - 0)
      );
      return NP.strip(num)
    },
    // 实际支付
    actualAmount() {
      let num = 0
      num = (
        this.total.domesticFreight - 0 +
        (this.total.additionalServiceCharge - 0) +
        (this.poundage - 0) +
        (this.detail.other_price - 0)
      );
      if (!this.detail.goods_fee_rule) {
        num += this.total.goodsAmount
      }
      if (this.detail.service_fee_rule) {
        num += this.total.goodsAmount * this.personalProcedures
      }
      return NP.strip(num)
    },
    // 手续费 单番手续费
    poundage() {
      let num = 0
      this.detail.order_detail.forEach((item) => {
        if (this.status == 20) {
          num += NP.strip(item.price * item.num * item.service_rate)
        } else if (this.status == 21) {
          num += NP.strip(item.confirm_num * item.confirm_price * item.service_rate)
        } else {
          num += NP.strip(item.offer_price * item.offer_num * item.service_rate)
        }
      })
      return this.ceil((NP.strip(num)));
    },
    // 国际物流
    logistics() {
      let logisticsList = JSON.parse(JSON.stringify(this.logisticsList))
      // logisticsList.forEach(item => {
      //   this.logisticsFreight.forEach(items => {
      //     if (item.id == items.logistics_id) {
      //       item.name = item.name + ` ` + (items.total_money_rmb * this.baseRate).toFixed(0) + '円'
      //     }
      //   })
      // })
      return logisticsList
    },
    // 是否定制
    isCustomMade() {
      let ids = [329990, 331032, 71]
      let flag = ids.some(item => item == this.detail.user_id)
      return flag
    },
  },
  methods: {
    //预估运费
    estimatedShipping() {
      // if(!this.total.totalWeight  ||!this.total.totalVolume=='')return false
      let datas = {
        datetime: '',
        list: [{
          weight: this.total.totalWeight,
          volume: this.total.totalVolume,
        }]
      }
      this.$api.porderApi.predictLogisticsPrice(datas).then((res) => {
        this.logisticsFreight = res.data
        let item = res.data.find(item => item.logistics_id == this.detail.logistics_id)

        if (item != undefined) {
          this.detail.predict_logistics_price = (item.total_money_rmb * this.baseRate).toFixed(0)
        } else {
          this.$message.error('未匹配到客户指定运公司，不可预估')
        }

      });
    },
    // 其它预估费用查看
    estimatedShippingLook() {
      this.forecastExpense = {
        datetime: '',
        list: [{
          weight: this.total.totalWeight,
          volume: this.total.totalVolume,
        }]
      }
      this.$refs.InternationalFreight.dialogVisible = true
    },
    //修改物流方式
    updateOrderLogistics(e) {
      let datas = {
        order_sn: this.order_sn,
        logistics_id: e
      }
      this.$api.orderApi.updateOrderLogistics(datas)
    },
    beforeAvatarUpload(file) {
      const isLt1000M = file.size / 1024 / 1024 < 1000;
      if (!isLt1000M) {
        this.$message.error('上传文件大小不能超过 1000MB!');
      }
      return isLt1000M;
    },
    //上传成功
    handleAvatarSuccess(res, name) {
      let datas = {
        order_sn: this.order_sn,
        file: res.data,
        name,
        admin_id: this.userRoleInfo.id,
        created_at: transferDate(new Date()),
        admin: {
          realname: this.userRoleInfo.realname,
          id: this.userRoleInfo.id,
        }
      }
      this.$api.orderApi.storeOrderFile(datas).then(res => {
        datas.id = res.data.id
        this.detail.order_file.push(datas)
        this.$message.success(res.msg)
      })
    },
    // 删除
    deleteOrderFile(id, i) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.hint"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.orderApi.deleteOrderFile({ id }).then((res) => {
            this.$message.success(res.msg);
            this.detail.order_file.splice(i, 1)
          });
        })
        .catch(() => { });
    },
    //跟进备注
    followRemarkEdit() {
      let datas = {
        order_sn: this.order_sn,
        follow_remark: this.detail.follow_remark
      }
      this.$api.orderApi.followRemarkEdit(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    //修改计算绩效规则
    updateOrderPerformance() {
      let datas = {
        order_sn: this.order_sn,
        is_y_performance: this.detail.order_augment.is_y_performance ? 1 : 0,
        is_g_performance: this.detail.order_augment.is_g_performance ? 1 : 0,
        is_p_performance: this.detail.order_augment.is_p_performance ? 1 : 0,
      }
      this.$api.orderApi.updateOrderPerformance(datas)
    },
    // 图片上传事件
    async httpup(file) {

      let data = await this.createClient(file)
      console.log(file.file.name);

      this.handleAvatarSuccess(data, file.file.name)
    },
    // 是否输入的小数
    handleInput(value, type) {
      this.detail.other_price = ("" + this.detail.other_price) // 第一步：转成字符串
        .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
        .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
        .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
    },

    //转寄订单-标记订单手否收商品金额及手续费
    updateOrderPayRule() {
      let updateOrderPayRule = {
        order_sn: this.order_sn,
        goods_fee_rule: this.detail.goods_fee_rule ? 1 : 0,
        service_fee_rule: this.detail.service_fee_rule ? 1 : 0,
      }
      this.$api.orderApi
        .updateOrderPayRule(updateOrderPayRule)
    },
    // 订单批量更新价格-计算
    orderBulkPrice(type, price) {
      this.detail.order_bulk[type] = ("" + this.detail.order_bulk[type]) // 第一步：转成字符串
        .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
        .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
        .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
        .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数

    },
    // 订单批量更新价格
    orderBulkUpdatePrice(type, price) {
      let datas = {
        order_sn: this.order_sn,
        price,
        column: type,
      }
      this.$api.orderApi.orderBulkUpdatePrice(datas).then(res => {
        this.$message.success(res.msg)
      })
    },
    // 下载原価計算書
    downloadCostCalculation() {
      let datas = {
        order_sn: this.order_sn,
        user_id: this.detail.user_id,
        export: 1,
      }
      // 设置responseType为blob以处理文件流
      this.$api.orderApi.bulkOrderPrice(datas, {
        responseType: 'blob'
      }).then(res => {
        // 创建blob对象
        const blob = new Blob([res.data], {
          type: 'application/vnd.ms-excel' // 根据实际文件类型设置
        });
        // 创建URL
        const url = window.URL.createObjectURL(blob);
        // 创建a标签
        const link = document.createElement('a');
        link.href = url;
        // 设置下载文件名
        link.download = `原価計算書_${this.order_sn}.xlsx`;
        // 模拟点击下载
        document.body.appendChild(link);
        link.click();
        // 清理资源
        window.URL.revokeObjectURL(url);
        document.body.removeChild(link);
      }).catch(error => {
        console.error('下载失败:', error);
        this.$message.error('原価計算書下载失败');
      })
    },
    // 业务翻译订单备注编辑
    yRemarkEdit() {
      let datas = {
        order_sn: this.order_sn,
        remark: this.detail.y_remark,
        remark_type: 1,
      }
      this.$api.orderApi.updateRemark(datas).then(res => {
        this.$message.success(res.msg)

      })
    }
  }
}
</script>
<style lang='scss' scoped>
.footer {
  display: flex;

  margin: 24px;
  padding-bottom: 20px;

  .item {
    flex: 1;
    padding: 24px;
    background: #f8f8f8;
    // border: 1px solid #edeff4;
    border-radius: 8px;
    margin-right: 24px;

    h6 {
      font-size: 18px;
      padding-bottom: 20px;
    }

    .border {
      height: 1px;
      background-color: #edeff4;
      margin-bottom: 20px;
    }

    .row.small-order-fee-exempt {
      .label {
        flex: none;
        margin-right: 24px;
        white-space: nowrap;
      }

      .input {
        flex: 1;
      }
    }

    .row {
      margin-bottom: 5px;
      display: flex;
      line-height: 42px;

      .label {
        flex: 1;
        font-weight: bold;
      }

      .rmb {
        flex: 1;
      }

      .ry {
        flex: 1;
      }

      .input {
        flex: 2;
      }

      .estimate {
        position: relative;

        .text {
          border: 1px solid #dcdfe6;
          height: 38px;
          padding: 0 10px;
          border-radius: 5px;
          background-color: #fff;
          line-height: 38px;
        }

        .el-button {
          position: absolute;
          right: 10px;
          top: 3px;
        }

        i {
          font-size: 20px;
          cursor: pointer;
        }
      }

      .attachment {
        flex: 1;
        margin-bottom: 5px;
        display: flex;

        .name {
          flex: 10;

          .time {
            display: inline-block;
            color: #B4272D;
            margin-left: 5px;
          }
        }

        .del {
          span {
            color: #32323C;
          }

          margin-left: 10px;
        }

        img {
          height: 32px;
          width: 32px;
          margin-right: 7px;
          vertical-align: middle;
        }

        span {
          line-height: 32px;
          color: #2c96e7;
          text-decoration: underline;
          cursor: pointer;
        }
      }
    }

    /deep/.el-textarea__inner {
      height: 100px;
    }
  }

  .international {
    flex: 0.8;
  }

  .commodityMaterial {
    background: #f8f8f8;
    border: 1px solid #edeff4;
    border-radius: 8px;
    padding: 24px;
    margin-bottom: 24px;

    .row {
      display: flex;
      flex-wrap: wrap;

      .label {
        width: 100px;
        font-size: 18px;
        font-weight: 500;
      }

      .val {
        width: 190px;
        background-color: #fff;
        padding: 0px 17px;
        border: 1px solid #dcdfe6;
        border-radius: 4px;
      }
    }
  }
}

/deep/ .is-disabled {
  .el-checkbox__inner,
  .el-checkbox__label {
    color: #606266 !important;
  }
}
</style>
